module.exports = __webpack_public_path__ + "static/media/hamburger-icon.66a6745d.svg";